import api from './api'

const userService = {
  async list() {
    const response = await api.get('/users')
    return response.data
  },

  async create(data) {
    const response = await api.post('/users', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/users/${id}`, data)
    return response.data
  },

  async remove(id) {
    const response = await api.delete(`/users/${id}`)
    return response.data
  },
}

export const ROLE_LABELS = {
  admin: 'Quản trị (Admin)',
  hr_manager: 'Trưởng phòng NS',
  team_lead: 'Trưởng nhóm',
  member: 'Nhân viên',
}

export const ROLE_BADGE = {
  admin: 'badge-danger',
  hr_manager: 'badge-primary',
  team_lead: 'badge-info',
  member: 'badge-neutral',
}

// Thứ tự vai trò cho dropdown
export const ROLE_OPTIONS = ['admin', 'hr_manager', 'team_lead', 'member']

export default userService
